<template>
    <div class="top" :class="{'top_vip' : Info.memberInfo.isMember}" ref="top">
        <img 
            v-if="Info.memberInfo.isMember" 
            class="vip_img"
            src="https://appd.knowbox.cn/ss/activity/parent_frontend/member/top_vip_bg.png" 
            alt="">
        <img 
            v-else 
            src="https://appd.knowbox.cn/ss/activity/parent_frontend/member/top_bg.png" 
            alt="">
        <div class="title_box">
          <div class="title" ref="title">
            <span class="back" @click="goBack">
                <i :class="{'i_vip' : Info.memberInfo.isMember}"></i>
            </span>
            <span v-if="!Info.needUpgrade">开通会员</span>
            <span v-else>会员升级</span>
          </div>
          <transition name="fade">
            <div class="title fixed" v-show="flag">
              <span class="back" @click="goBack">
                  <i :class="{'i_vip' : Info.memberInfo.isMember}"></i>
              </span>
              <span v-if="!Info.needUpgrade">开通会员</span>
              <span v-else>会员升级</span>
            </div>
          </transition>
        </div>
        <div class="user_info">
            <div class="head head_vip" v-if="Info.memberInfo.isMember"></div>
            <div class="head" v-else></div>
            <div class="intro">
                <div class="name">{{ Info.memberInfo.username }}</div>
                <div class="desc" v-if="!Info.needUpgrade">{{ Info.memberInfo.memberDesc }}</div>
                <div class="desc" v-else>
                    <span v-if="Info.superMember">超级会员&nbsp;剩余{{ Info.superMember }}天</span>
                    <span v-if="Info.syncTest">同步练会员&nbsp;剩余{{ Info.syncTest }}天</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { MOBILE_API } from "@/constants/api";
    import utils from "@/assets/js/utils";
    const token = utils.getQueryString('token');
    const version = utils.getQueryString('version');
    const source = utils.getQueryString('source');
    const categoryId = utils.getQueryString('categoryId');
    const pageChannelId = utils.getQueryString('pageChannelId');

    export default {
        props: {
            Info: {
                type: Object
            }
        },
        data(){
          return {
            offsetTop: 0,
            offsetHeight: 0,
            flag:false
          }
        },
        methods: {
            goBack() {
                window.location.href = MOBILE_API.EXIT;
            },
            handleScroll() {
              // 得到页面滚动的距离，兼容写法
              let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
              // 判断页面滚动的距离是否大于吸顶元素的位置
            //   console.log(scrollTop)
              console.log(this.offsetTop)
              
              this.flag = scrollTop > this.offsetTop
            }
        },
        created() {
            if(this.Info.needUpgrade) {
                utils.sendLog(
                    {
                        token: token,
                        version: version,
                        source: source,
                        extensionJson: {
                            categoryId: categoryId,
                            pageChannelId: pageChannelId
                        }
                    },
                    "vipUpdatePage_update_click"
                );

            }else {
                utils.sendLog(
                    {
                        token: token,
                        version: version,
                        source: source,
                        extensionJson: {
                            categoryId: categoryId,
                            pageChannelId: pageChannelId
                        }
                    },
                    "vipOpenPgae_show"
                );
            }
        },
        mounted() {
          this.$nextTick(() => {
            // 获取吸顶元素的dom
            let title = this.$refs.title;
            // 吸顶元素到top的距离
            this.offsetTop = title.offsetTop;
            // 元素自身的高度
            this.offsetHeight = this.$refs.top.offsetHeight;
            // 监听滚动条
            window.addEventListener("scroll", this.handleScroll);
          })
        },
        destroyed() {
          window.removeEventListener('scroll', this.handleScroll);
        },
    }
</script>

<style lang="scss" scoped>
    .top {
        // height: 2.4rem;
        overflow: hidden;
        background-image: linear-gradient(90deg, 
		#dab673 0%, 
		#f0d8a8 100%);
        color: #ffffff;
        position: relative;
        img {
            position: absolute;
            width: 2.7rem;
            height: 2.01rem;
            bottom: 0.44rem;
            right: 0;
        }
        .vip_img {
            width: 2.55rem;
            height: 1.36rem;
        }
        .title {
            height: .7rem;
            font-size: .34rem;
            // background: #229bff;
            line-height: .7rem;
            position: relative;
            margin-top: .5rem;
            color: #946b3e;
            .back {
                display: inline-block; 
                position: absolute;
                left: .2rem;
                padding: 0 .2rem;
                i {
                    display: inline-block;
                    width: .19rem;
                    height: .19rem;
                    border-left: .02rem solid rgba(0, 0, 0, 0.8);
                    border-top: .02rem solid rgba(0, 0, 0, 0.8);
                    transform: rotate(-45deg);
                }
                .i_vip {
                    border-left: .02rem solid #42301b;
                    border-top: .02rem solid #42301b;
                }
            }
        }
        .fixed {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 0;
          background-color: #ffffff;
          color: #000;
          position: fixed;
          top:0;
          left:0;
          height: 1.2rem;
          width: 100%;
          z-index: 50;
          box-sizing: content-box;
          padding-top: constant(safe-area-inset-top);
          padding-top: env(safe-area-inset-top);
        }
        .user_info {
            height: 1.7rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            padding: 0 .4rem;
            box-sizing: content-box;
            padding-bottom: .44rem;
            .head {
                width: .64rem;
                height: .64rem;
                border-radius: 50%;
                background: #ffffff url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_vip_gray.png) center center no-repeat;
                background-size: .44rem .44rem;
                &_vip {
                    background: #ffffff url(https://appd.knowbox.cn/ss/activity/parent_frontend/member/icon_vip_light.png) center center no-repeat;
                    background-size: .44rem .44rem;
                }
            }
            .intro {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                margin-left: .2rem;
                height: .78rem;
                .name {
                    font-family: PingFangSC-Semibold;
                    font-weight: bold;
                    font-size: .32rem;
                    color: #fff;
                }
                .desc {
                    font-size: .22rem;
                    color: #fff;
                    span {
                        display: inline-block;
                        &:nth-child(2) {
                            margin-left: .54rem;
                        }
                    }
                }
            }

        }
        &_vip {
            background-image: linear-gradient(90deg, 
		#dab673 0%, 
		#f0d8a8 100%);
            color: #624525;
            .user_info {
                .intro {
                    .name {
                        color: #8c653b
                    }
                    .desc {
                        color: #946b3e;
                    }
                }
            } 

        }
    }
    .fade-enter-active, .fade-leave-active {
      transition: opacity 0.2s;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>